import { HostedInstanceResource } from "client/resources/hostedInstanceResource";
import { AssignedVersionUpgradeStrategy, AssignedVersionIgnoreMaintenanceWindowUpgradeStrategy, EphemeralInstanceAssignedVersionUpgradeStrategy, UpgradeStrategyType } from "client/resources/upgradeStrategy";

export function displayInstanceVersion(instance: HostedInstanceResource) {
    let versionSuffix = "";
    if (instance.UpgradeStrategy.UpgradeStrategyType === UpgradeStrategyType.NoAutomaticUpgradeStrategy)
        versionSuffix = "No auto upgrade";
    else if (instance.UpgradeStrategy.UpgradeStrategyType === UpgradeStrategyType.TrackBranchUpgradeStrategy)
        versionSuffix = "Tracking branch";
    else if (instance.UpgradeStrategy.UpgradeStrategyType == UpgradeStrategyType.AssignedVersionUpgradeStrategy)
        versionSuffix = (instance.UpgradeStrategy as AssignedVersionUpgradeStrategy).Version;
    else if (instance.UpgradeStrategy.UpgradeStrategyType == UpgradeStrategyType.TrackDefaultVersionUpgradeStrategy)
        versionSuffix = "Tracking default version";
    else if (instance.UpgradeStrategy.UpgradeStrategyType == UpgradeStrategyType.AssignedVersionIgnoreMaintenanceWindowUpgradeStrategy)
        versionSuffix = (instance.UpgradeStrategy as AssignedVersionIgnoreMaintenanceWindowUpgradeStrategy).Version;
    else if (instance.UpgradeStrategy.UpgradeStrategyType == UpgradeStrategyType.EphemeralInstanceAssignedVersionUpgradeStrategy)
        versionSuffix = (instance.UpgradeStrategy as EphemeralInstanceAssignedVersionUpgradeStrategy).Version;

    return instance.Version ? `${instance.Version} (${versionSuffix})` : "[Not Set]";
}
